var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTooltipS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1010 10A10 10 0 0010 0zm.35 15A1.28 1.28 0 019 13.74a1.25 1.25 0 011.33-1.24 1.25 1.25 0 011.34 1.24A1.28 1.28 0 0110.35 15zm1.05-3.49H9.3c0-1.94 2.17-2.37 2.17-3.58 0-.68-.6-1.11-1.5-1.11a2.37 2.37 0 00-2 1l-1.68-1A4.43 4.43 0 0110.2 5c2.09 0 3.53.93 3.53 2.57 0 2.22-2.33 2.43-2.33 3.94z"
  })));
}

export default SvgIconTooltipS;